import { DEPARTMENT_IFT } from 'components/ProductListingPageTheme2/FilterSlidebar';
import { ReOrderTypes } from 'config/constant';
import {
  FETCH_PRODUCT_LIST_BY_DEPARTMENT,
  FETCH_PRODUCT_LIST_BY_DEPARTMENT_SUCCESS,
  FETCH_PRODUCT_LIST_BY_DEPARTMENT_FAILURE,
  FETCH_FILTER_OPTIONS_LIST,
  FETCH_FILTER_OPTIONS_LIST_SUCCESS,
  FETCH_FILTER_OPTIONS_LIST_FAILURE,
  UPDATE_SORT_BY_VALUE,
  UPDATE_PAGE_LIMIT,
  UPDATE_IFT_CHECK_LIST,
  EMPTY_IFT_CHECK_LIST,
  UPDATE_PAST_ORDER_LIST,
  UPDATE_ACTIVE_PAGE,
  FETCH_DEPARTMENT_TREE,
  FETCH_DEPARTMENT_TREE_SUCCESS,
  FETCH_DEPARTMENT_TREE_FAILURE,
  UPDATE_PRICE_VALUE,
  UPDATE_NODE_FUNCTIONAL_TEXT,
  UPDATE_NODE_FUNCTIONAL_LEVEL,
  SEARCH_DEPARTMENT_TREE,
  SEARCH_DEPARTMENT_TREE_SUCCESS,
  SEARCH_DEPARTMENT_TREE_FAILURE,
  RESET_FILTER_SIDEBAR,
  FETCH_PRODUCT_DETAILS,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  FETCH_PRODUCT_DETAILS_FAILURE,
  FETCH_RELATED_PRODUCT_LIST,
  FETCH_RELATED_PRODUCT_LIST_SUCCESS,
  FETCH_RELATED_PRODUCT_LIST_FAILURE,
  UPDATE_FROM_LIST,
  SAVE_CURRENT_DEPARTMENT,
  WEEKLY_SALES_SELECTED,
  UPDATE_DEPARTMENT_NAME,
  GET_PRODUCTS_UPC_WISE_FAILURE,
  GET_PRODUCTS_UPC_WISE_SUCCESS,
  GET_PRODUCTS_UPC_WISE_REQUEST,
  FETCH_PRODUCT_INFO,
  FETCH_PRODUCT_INFO_SUCCESS,
  FETCH_PRODUCT_INFO_FAILURE,
  UPDATE_SEARCH_AND_APPLY_EBT_FILTER,
  UPDATE_TEXT_FILTERS,
  RESET_TEXT_FILTERS,
  RESET_TEXT_FILTERS_FOR_GROUP,
  UPDATE_MODAL_PRODUCT,
  SET_RE_ORDER_TYPE
} from "redux/constants/actionTypes";

let initialState = {
  productListByDepartment: [],
  productListByDepartmentLoading: false,
  productListByDepartmentError: "",
  productListByDepartmentTotalCount: 0,
  productListByDepartmentTotalPages: 0,
  categoryadsSection: {},
  filterOptionList: {},
  filterOptionListLoading: false,
  filterOptionListError: "",
  activePageNo: 1,
  pageLimit: "",
  iftCheckedList: [],
  fromCheckedList: [],
  pastOrderCheckedList: [],
  sortByValue: "",
  maxPriceValue: "",
  minPriceValue: "",
  functionalText: "",
  functionalLevel: "",
  departmentTree: [],
  departmentTreeLoading: false,
  departmentTreeError: "",
  searchDepartmentTree: [],
  searchDepartmentTreeLoading: false,
  searchDepartmentTreeError: "",
  nodeFunctionalText: "",
  nodeFunctionalLevel: "",
  productDetails: null,
  productDetailsLoading: false,
  productDetailsError: "",
  relatedProductList: [],
  relatedProductListLoading: false,
  relatedProductListError: "",
  currentDepartment: "",
  filterOptions: [],
  weeklySalesSelected: false,
  selectedDepartmentName: "",
  productsUpcWise: [],
  productsUpcWiseLoading: false,
  productsUpcWiseError: "",
  memoryToken: "",
  productInfo: {},
  productInfoLoading: false,
  productInfoError: "",
  selectedCustomOptions: [],
  searchAndApplyEbtFilter: "",
  textFilters: {},
  priceRange: undefined,
  modalProduct: undefined,
  reOrderType: ReOrderTypes.ecom
};

const productListByDepartmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_LIST_BY_DEPARTMENT:
      return {
        ...state,
        productListByDepartmentLoading: true,
        productListByDepartment: [],
      };
    case FETCH_PRODUCT_LIST_BY_DEPARTMENT_SUCCESS:
      const { searchEbt, ...payload } = action.payload;
      const iftFilter = {}
      if (searchEbt && state.searchAndApplyEbtFilter === "start") {
        iftFilter.iftCheckedList = ["ebt_item"]
        iftFilter.searchAndApplyEbtFilter = "complete"
      }

      let filtersUpdated = false
      const textFilters = {...state.textFilters}
      const filterOptions = payload.filters ?? []
      for (const filter of filterOptions) {
        const values = filter?.values
        if (Array.isArray(filter?.values) && values?.length > 0) {
          const {ift} = filter

          if (ift === "department_number") {
            continue
          }

          if (textFilters?.[ift]?.length) {
            if (textFilters[ift].some(v => !values.includes(v))) {
              filtersUpdated = true
              textFilters[ift] = textFilters[ift].filter(v => values.includes(v))
              textFilters[ift].sort((a, b) => a > b)
            }
          }
        }
      }
      
      const data = {
        ...state,
        productListByDepartmentLoading: false,
        productListByDepartment: payload.data,
        filterOptions: payload.filters,
        priceRange: payload?.price_section,
        productListByDepartmentTotalCount: payload.TotalRecords || 0,
        productListByDepartmentTotalPages: payload.NoOfPages || 0,
        categoryadsSection: payload.categories_section,
        memoryToken: payload.memoryToken,
        ...iftFilter
      }

      if (filtersUpdated) {
        data.textFilters = textFilters
      }

      return data;
    case FETCH_PRODUCT_LIST_BY_DEPARTMENT_FAILURE:
      return {
        ...state,
        productListByDepartmentError: action.payload.error,
        productListByDepartmentLoading: false,
      };

    // Filter option list
    case FETCH_FILTER_OPTIONS_LIST:
      return {
        ...state,
        filterOptionListLoading: true,
      };
    case WEEKLY_SALES_SELECTED:
      return {
        ...state,
        weeklySalesSelected: action.payload,
      };
    case UPDATE_DEPARTMENT_NAME:
      return {
        ...state,
        selectedDepartmentName: action.payload,
      };
    case FETCH_FILTER_OPTIONS_LIST_SUCCESS:
      return {
        ...state,
        filterOptionListLoading: false,
        filterOptionList: action.payload,
      };
    case FETCH_FILTER_OPTIONS_LIST_FAILURE:
      return {
        ...state,
        filterOptionListError: action.payload.error,
      };
    case RESET_FILTER_SIDEBAR:
      return {
        ...state,
        activePageNo: 1,
        pageLimit: "",
        iftCheckedList: [],
        sortByValue: "",
        maxPriceValue: "",
        minPriceValue: "",
        textFilters: {},
        functionalText: "",
        functionalLevel: "",
        currentDepartment: ""
      };
    case UPDATE_SORT_BY_VALUE:
      return {
        ...state,
        sortByValue: action.payload,
        activePageNo: 1,
      };
    case UPDATE_PAGE_LIMIT:
      return {
        ...state,
        pageLimit: action.payload,
        activePageNo: 1,
      };
    case UPDATE_IFT_CHECK_LIST:
      if (action.isWeeklyAds) {
        // for auto selecting weekly ads from shop by department
        return {
          ...state,
          iftCheckedList: [action.payload],
          activePageNo: 1,
        };
      }

      let updatedIftCheckedList = state.iftCheckedList;

      if (updatedIftCheckedList.includes(action.payload)) {
        updatedIftCheckedList = updatedIftCheckedList.filter(
          (iftType) => iftType !== action.payload
        );
      } else {
        updatedIftCheckedList.push(action.payload);
      }

      return {
        ...state,
        iftCheckedList: updatedIftCheckedList,
        activePageNo: 1,
      };

    case EMPTY_IFT_CHECK_LIST:
      return { ...state, iftCheckedList: [], activePageNo: 1 };

    case UPDATE_FROM_LIST:
      let updatedFromList = state.fromCheckedList;

      if (updatedFromList.includes(action.payload)) {
        updatedFromList = updatedFromList.filter(
          (fromList) => fromList !== action.payload
        );
      } else {
        updatedFromList.push(action.payload);
      }

      return {
        ...state,
        fromCheckedList: updatedFromList,
        activePageNo: 1,
      };
    case UPDATE_PAST_ORDER_LIST:
      let pastOrderList = state.pastOrderCheckedList;

      if (pastOrderList.includes(action.payload)) {
        pastOrderList = pastOrderList.filter(
          (pastDate) => pastDate !== action.payload
        );
      } else {
        pastOrderList.push(action.payload);
      }

      return {
        ...state,
        pastOrderCheckedList: pastOrderList,
        activePageNo: 1,
      };

    case UPDATE_ACTIVE_PAGE:
      return {
        ...state,
        activePageNo: action.payload,
      };

    case UPDATE_PRICE_VALUE:
      return {
        ...state,
        minPriceValue: action.payload[0],
        maxPriceValue: action.payload[1],
      };

    // Department tree view
    case FETCH_DEPARTMENT_TREE:
      return {
        ...state,
        departmentTreeLoading: true,
      };
    case FETCH_DEPARTMENT_TREE_SUCCESS:
      return {
        ...state,
        departmentTreeLoading: false,
        departmentTree: action.payload,
      };
    case FETCH_DEPARTMENT_TREE_FAILURE:
      return {
        ...state,
        departmentTreeError: action.payload.error,
      };

    // Product details
    case FETCH_PRODUCT_DETAILS:
      return {
        ...state,
        productDetailsLoading: true,
        productDetails: null,
      };
    case FETCH_PRODUCT_DETAILS_SUCCESS: {
      const data = action.payload
      if ("custom_options" in data) {
        const customOptions = data.custom_options
        for (const customOption of customOptions) {
          const title = customOption.title
          if (title && customOption.values) {
            customOption.values = customOption.values?.map(i => ({
              ...i,
              label: title
            }))
          }
        }
      }

      return {
        ...state,
        productDetailsLoading: false,
        productDetails: data,
      };
    }
    case FETCH_PRODUCT_DETAILS_FAILURE:
      return {
        ...state,
        productDetailsError: action.payload.error,
      };

    // Related prioduct list
    case FETCH_RELATED_PRODUCT_LIST:
      return {
        ...state,
        relatedProductListLoading: true,
      };
    case FETCH_RELATED_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        relatedProductListLoading: false,
        relatedProductList: action.payload,
      };
    case FETCH_RELATED_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        relatedProductListError: action.payload.error,
      };

    // Search Department tree view
    case SEARCH_DEPARTMENT_TREE:
      return {
        ...state,
        searchDepartmentTreeLoading: true,
      };
    case SEARCH_DEPARTMENT_TREE_SUCCESS:
      return {
        ...state,
        searchDepartmentTreeLoading: false,
        searchDepartmentTree: action.payload,
      };
    case SEARCH_DEPARTMENT_TREE_FAILURE:
      return {
        ...state,
        searchDepartmentTreeError: action.payload.error,
      };
    case UPDATE_NODE_FUNCTIONAL_TEXT:
      return {
        ...state,
        nodeFunctionalText: action.payload,
      };
    case UPDATE_NODE_FUNCTIONAL_LEVEL:
      return {
        ...state,
        nodeFunctionalLevel: action.payload,
      };
    case SAVE_CURRENT_DEPARTMENT:
      return {
        ...state,
        currentDepartment: action.payload,
      };
    case GET_PRODUCTS_UPC_WISE_REQUEST:
      return {
        ...state,
        productsUpcWiseLoading: true,
      };
    case GET_PRODUCTS_UPC_WISE_SUCCESS:
      return {
        ...state,
        productsUpcWiseLoading: false,
        productsUpcWise: action.payload,
      };
    case GET_PRODUCTS_UPC_WISE_FAILURE:
      return {
        ...state,
        productsUpcWiseError: action.payload.error,
      };
    case FETCH_PRODUCT_INFO:
      return {
        ...state,
        productInfoLoading: true,
      };
    case FETCH_PRODUCT_INFO_SUCCESS:
      return {
        ...state,
        productInfoLoading: false,
        productInfo: action.payload,
      };
    case FETCH_PRODUCT_INFO_FAILURE:
      return {
        ...state,
        productInfoLoading: false,
        productInfoError: action.payload.error,
      };
    case UPDATE_SEARCH_AND_APPLY_EBT_FILTER:
      return {
        ...state,
        searchAndApplyEbtFilter: action.payload,
        iftCheckedList: action.payload === "start" ? ["ebt_item"] : state.iftCheckedList,
      };
    case UPDATE_TEXT_FILTERS:
      const {category: categoryName, value} = action.payload
      let newTextFilters = {...state.textFilters}
      let resetState = {}
      if (categoryName === DEPARTMENT_IFT) {
        // reset other filter on department change
        newTextFilters = {
          [categoryName]: [...(state?.textFilters?.[categoryName] ?? [])]
        }
        resetState = {
          iftCheckedList: [],
          sortByValue: "",
          maxPriceValue: "",
          minPriceValue: "",
          pageLimit: "",
          activePageNo: 1,
        }
      }
      const category = newTextFilters[categoryName]
      
      if (!category) {
        newTextFilters[categoryName] = [value]
      } else {
        if (category.includes(value)) {
          newTextFilters[categoryName] = newTextFilters[categoryName].filter(v => v !== value)
        } else {
          newTextFilters[categoryName].push(value)
        }
      }
      return {
        ...state,
        textFilters: newTextFilters,
        ...resetState
      };
    case RESET_TEXT_FILTERS:
      return {
        ...state,
        textFilters: {},
      };
    case RESET_TEXT_FILTERS_FOR_GROUP:
      return {
        ...state,
        textFilters: {
          ...state.textFilters,
          [action.payload]: [],
        },
      };
    case UPDATE_MODAL_PRODUCT:
      return {
        ...state,
        modalProduct: action.payload,
      };
    case SET_RE_ORDER_TYPE:
      return {
        ...state,
        reOrderType: action.payload,
      };
    default:
      return state;
  }
};

export default productListByDepartmentReducer;
